<template>
    <div class="main-internal-section width-full float-l">
        <div class="container">
            <template v-if="cantAccessPage === true">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-lg-4"> <!--left section-->
                        <div class="row">

                            <div class="header-section col-12 float-l bgcolor-cfe3ee"> <!--header section-->
                                <div class="back-btn-chat float-l">
                                    <!-- <a href="#"> <i class="hi-icon icon-chatback"></i> </a> -->
                                    <router-link v-bind:to="{name: 'CustomerList'}"><i class="hi-icon icon-chatback"></i> </router-link>
                                </div>

                                <div class="customer-name float-l colpie-87">
                                    <p class="color-231f20 font-roboto-bold heading-text-16 line-height-20 agent-customer-name float-l width-full pt_10 pl_40 mb_0"> {{customerDetails.name}} (Customer Name)
                                    </p>
                                </div>
                                
                                <div class="menu-right-header float-r"> <!--header menu section-->
                                    <div class="nc-chat-right-dropdown">
                                        <div class="dropdown">
                                            <!--  <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">
                                                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                            </button> -->

                                            <button class="more-btn btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">
                                                <span class="more-dot"></span>
                                                <span class="more-dot"></span>
                                                <span class="more-dot"></span>
                                            </button>

                                            <ul class="dropdown-menu">
                                                <!-- <p class="user-name color-f5911e heading-text-14 line-height-20 font-benton-bold float-l width-full">
                                                    <span v-if="status == 'Online' || status == 'online'" class="bgcolor-5cbb55 p_5 pull-left absolute l-15 t-5 radius-100"></span>
                                                    <span v-else class="bgcolor-ff3636 p_5 pull-left absolute l-15 t-5 radius-100"></span>
                                                    {{userName}}
                                                    
                                                </p> -->
                                                <li> <a href="site-list.html"> My Sites <span> <i class="fa fa-angle-right custom" ></i> </span> </a> </li>
                                                <li> <router-link v-bind:to="{name: 'UserList'}"> User List <span> <i class="fa fa-angle-right custom" ></i> </span> </router-link> </li>
                                                <li> <router-link v-bind:to="{name: 'CustomerList'}"> Customer List <span> <i class="fa fa-angle-right custom" ></i> </span> </router-link> </li>
                                                <li> <router-link v-bind:to="{name: 'ArchivedChat'}"> Archived Chat <span> <i class="fa fa-angle-right custom" ></i> </span> </router-link> </li>
                                                <li> <a v-on:click.prevent="logoutMobileViewCustomerDetailsSide" href="javascript:void(0)"> Sign Out <span> <i class="fa fa-angle-right custom" ></i> </span> </a> </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div> <!--header menu section-->
                            </div> <!--header section-->

                            <div class="chat-btm-section-main add-user-main-section width-full float-l"> <!--middle section-->

                                <div class="add-user-form update-user-top-section customer-detail-form col-12 float-l mt_10 ">
                                    <div class="form-group float-l width-full p_15">
                                        <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Email </p>
                                        <input type="text" class="form-control custom-select" :placeholder="customerDetails.email" disabled>
                                        <span> <i class="hi-icon icon-chatemail"></i> </span>
                                    </div>

                                    <div class="form-group float-l width-full p_15">
                                        <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Phone </p>
                                        <input type="text" class="form-control custom-select" :placeholder="customerDetails.phone" disabled>
                                        <span> <i class="hi-icon icon-chatphone-call"></i> </span>
                                    </div>

                                    <div class="form-group float-l width-full p_15">
                                        <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Created Date & Time </p>
                                        <input type="text" class="form-control custom-select" :placeholder="customerDetails.date" disabled>
                                        <!-- :placeholder="customerDetails.created_at" -->
                                        <!-- placeholder="05-27-2019 &nbsp; &nbsp; 02:17:46" -->
                                        <span> <i class="hi-icon icon-chatcalendar-1"></i> </span>
                                    </div>

                                    <div class="form-group float-l width-full p_15">
                                        <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Section </p>
                                        <input type="text" class="form-control custom-select" :placeholder="customerDetails.sections" disabled>
                                        <span> <i class="hi-icon icon-chatdelivery-truck"></i> </span>
                                    </div>
                                </div> 
                            </div> <!--middle section-->	
                            
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <template v-if="isRequestComplete">
                    <div class="col-md-12">
                        <div class="error-template">
                            <h1>
                                Oops!</h1>
                            <h2>
                                403 </h2>
                            <div class="error-details">
                                Sorry!, You don't have permission to access this page.
                            </div>
                        </div>
                    </div>
                </template>
            </template>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import moment from 'moment';
    import EventBus from '../event-bus';

    Vue.component("app-footer", Footer);
    export default {
        name: 'CustomerDetail',
        mixins: [commonMixins],
        data () {
            return {
                cantAccessPage: true,
                isRequestComplete: false,
                customerDetails: [],
            }
        },
        mounted: function() {
            var self = this;
            self.loadCustomerDetails();
            EventBus.$emit("headerMobileView", 'Customer Detail');

            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.logingId = userJson["id"];
                self.userName = userJson['name'];
            }
            self.getPermissions();
        },
        filters: {
            filtersGetName(value, value2) {

                let name1 = value2.split(" ");
                if(name1[1] && name1[1] != '') {
                    let getName = name1[0].charAt(0) + name1[1].charAt(0);
                    return getName.toUpperCase();
                }
                if(value) {
                    let name = value.charAt(0);
                    let splitData = value.split("@");
                    name += splitData[1].charAt(0);
                    return name.toUpperCase();
                }
            },
            filterUSting(data) {

                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            }
        },
        methods: {
            loadCustomerDetails: function() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                var fields = {
                    'user_id': segments[3]
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                self.showLoader();
                HTTP.post("get-details-by-id", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {

                            if (response.data.content != "") {
                                self.customerDetails = response.data.content;
                            }
                        }
                        self.hideLoader();
                    })
                    .catch(function (error) {
                        self.hideLoader();
                        self.catchHandler(error, function () {});
                    });
            },
            logoutMobileViewCustomerDetailsSide: function() {
                EventBus.$emit("logoutMobileSide", true);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// src/components/Customer/CustomerDetails.vue